// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3SpOF","wrapper-nopadding":"wrapper-nopadding__2IAv7","loading":"loading__1-4_q","error":"error__9QO_S","table-loading":"table-loading__inAOW","empty-val":"empty-val__2aoI6","panelheader-tools":"panelheader-tools__Ik6DI","propsPanels":"propsPanels__3aXYd","new":"new__2szAh","marginLm":"marginLm__2RQ6l","edit":"edit__172FN","marginRm":"marginRm__2xW1d","fullWidth":"fullWidth__1cfRO","fullHeight":"fullHeight__3aBrS","noData":"noData__3ubVb","icons":"icons__1-yHe","ok":"ok__6awN5","remove":"remove__2NBD1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/EditName/styles.scss
// module id = 2189
// module chunks = 1